import InitialPageData from '@classes/InitialPageData';
import getInitialData from '@hei/utils/getInitialData';
import makeRequest from '@hei/utils/makeRequest';

async function getInitialPageData() {
  let initialPageData = getInitialData<InitialPageData>();

  if (!initialPageData) {
    initialPageData = await makeRequest<InitialPageData>({
      action: 'Create',
      route: 'InitialPageData',
      origin: 'https://files.hendersonengineers.com'
    });
  }

  return initialPageData.googleKey;
}

export default getInitialPageData;
